import { render, staticRenderFns } from "./TimeDisplay.vue?vue&type=template&id=e8e61c18&scoped=true"
import script from "./TimeDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeDisplay.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TimeDisplay.vue?vue&type=style&index=0&id=e8e61c18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e61c18",
  null
  
)

export default component.exports